// extracted by mini-css-extract-plugin
export default {"searchPlaceholderWrapper":"search-placeholder_searchPlaceholderWrapper__iwQ5R","secondaryText":"search-placeholder_secondaryText__W1tLL"};